export enum InsertPosition {
  ABOVE = 'above',
  BELOW = 'below',
}
export interface AddBlockMenuProps {
  insertPosition: InsertPosition;
  blockIdsToRender?: string[];
}
